/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandardProductDto } from '../../models/backend-standard-product-dto';
import { BackendStandardProductRequestDto } from '../../models/backend-standard-product-request-dto';

export interface SalesStandardProductsUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendStandardProductRequestDto;
}

export function salesStandardProductsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandardProductDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandardProductDto>;
    }),
  );
}

salesStandardProductsUpdate$XWwwFormUrlencoded.PATH = '/api/sales/standard-products/{id}/';
